export enum LoginErrorCode {
  ForgotPassword = 'AADB2C90118',
  CancelFlow = 'AADB2C90091',
}
